import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiUsuarioService } from '../services/api-usuario.service';
import { map, take, filter } from 'rxjs/operators';
import { IntegracaoConstants } from '../constants/integracao';

@Injectable({
  providedIn: 'root'
})
export class UserPermissoesGuard  {

  constructor(private apiUsuario: ApiUsuarioService, private router: Router){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkUserPermissao(state.url);
  }

  private checkUserPermissao(url: string) {
      if (this.apiUsuario.grupoPermissoesUsuario() && this.apiUsuario.permissoesCorretora.length > 0) {
      return this.handlePermissaoCheck(url);
    }

    return this.apiUsuario.permissoesCarregadas$.pipe(
      filter(carregou => carregou),
      take(1),
      map(() => this.handlePermissaoCheck(url))
    );
  }

  private handlePermissaoCheck(url: string) {
    const permissaoResult = this.getIdPermissao(url);

    // Se permissaoResult for um array (caso de /config-coberturas)
    if (Array.isArray(permissaoResult)) {
      // Verifica se o usuário tem pelo menos uma das permissões necessárias
      const userPermissoes = this.apiUsuario.grupoPermissoesUsuario().permissoes;
      const temAlgumaPermissao = permissaoResult.some(id => userPermissoes.includes(id));

      if (temAlgumaPermissao) {
        return true;
      }
    }
    // Caso normal: permissaoResult é um único ID
    else if (permissaoResult && this.apiUsuario.grupoPermissoesUsuario().permissoes.includes(permissaoResult)) {
      return true;
    }

    this.router.navigate(['/cotacoes']);
    return false;
  }



  getIdPermissao(url) {
    if (url.includes('/config-coberturas')) {
      // Retorna todos os IDs de permissões relacionadas a coberturas
      const permissoesCoberturas = [
        this.apiUsuario.permissoesCorretora.COBERTURAS?.id,
        this.apiUsuario.permissoesCorretora.COBERTURAS_AUTO?.id,
        this.apiUsuario.permissoesCorretora.COBERTURAS_RESIDENCIAL?.id,
        this.apiUsuario.permissoesCorretora.COBERTURAS_EMPRESARIAL?.id,
        this.apiUsuario.permissoesCorretora.COBERTURAS_CONDOMINIO?.id,
        this.apiUsuario.permissoesCorretora.COBERTURAS_VIDA?.id,
        this.apiUsuario.permissoesCorretora.COBERTURAS_VIDA_GLOBAL?.id,
        this.apiUsuario.permissoesCorretora.COBERTURAS_ALUGUEL?.id,
        this.apiUsuario.permissoesCorretora.COBERTURAS_BIKE?.id,
        this.apiUsuario.permissoesCorretora.COBERTURAS_ACIDENTES_PESSOAIS?.id,
        this.apiUsuario.permissoesCorretora.COBERTURAS_CELULAR?.id
      ].filter(id => id !== undefined);

      return permissoesCoberturas;
    }

    // Comportamento padrão para outras rotas
    const matchedKey = Object.keys(IntegracaoConstants.rotasNomePermissoes).find(key => url.includes(key));
    return matchedKey ? this.apiUsuario.permissoesCorretora[IntegracaoConstants.rotasNomePermissoes[matchedKey]]?.id : undefined;
  }
}
